/**
 * React Rails
 */
/* eslint-disable */
// import '@babel/polyfill'

import Rails from '@rails/ujs'
Rails.start()
var vocRequireContext = require.context('components/voc', true)
var ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(vocRequireContext)

// import 'jquery/src/jquery'
// import 'jquery-ujs/src/rails'

// window.Global = {}
// window.Global.$ = $(
//   //eslint-disable-line

//   /**
//    * LazyLoad
//    * @see https://github.com/verlok/lazyload#-recipes
//    */
//   (function(w, d) {
//     var b = d.getElementsByTagName('body')[0]
//     var s = d.createElement('script')
//     var v = !('IntersectionObserver' in w) ? '8.17.0' : '10.19.0'
//     s.async = true // This includes the script as async. See the "recipes" section for more information about async loading of LazyLoad.
//     s.src =
//       'https://cdn.jsdelivr.net/npm/vanilla-lazyload@' +
//       v +
//       '/dist/lazyload.min.js'
//     w.lazyLoadOptions = {
//       elements_selector: '.lazy',
//     }
//     b.appendChild(s)
//   })(window, document)
// )
document.addEventListener("DOMContentLoaded", () => {
  /**
   * LazyLoad
   * @see https://github.com/verlok/lazyload#-recipes
   */
  (function(w, d) {
    var b = d.getElementsByTagName('body')[0]
    var s = d.createElement('script')
    var v = !('IntersectionObserver' in w) ? '8.17.0' : '10.19.0'
    s.async = true // This includes the script as async. See the "recipes" section for more information about async loading of LazyLoad.
    s.src =
      'https://cdn.jsdelivr.net/npm/vanilla-lazyload@' +
      v +
      '/dist/lazyload.min.js'
    w.lazyLoadOptions = {
      elements_selector: '.lazy',
    }
    b.appendChild(s)
  })(window, document)
})
